/* Paper colour toggle. The initial value is set inline in <head> to avoid a flash. */
(function () {
    'use strict';

    var STORAGE_KEY = 'vanta-plus-scheme';

    document.addEventListener('click', function (event) {
        var toggle = event.target.closest('[data-scheme-toggle]');
        if (!toggle) {
            return;
        }

        var root = document.documentElement;
        var next = root.getAttribute('data-scheme') === 'dark' ? 'light' : 'dark';
        root.setAttribute('data-scheme', next);

        try {
            localStorage.setItem(STORAGE_KEY, next);
        } catch (e) {
            /* storage unavailable: the choice lasts for this page only */
        }
    });
})();
